<template>
  <b-form>
    <b-form-group label="Родительский каталог">
      <b-form-select
        v-model="model.parent"
        :options="parents"
        value-field="id"
        text-field="title"
      />
    </b-form-group>
    <b-form-group label="Название каталога">
      <b-form-input
        v-model="model.title"
        @change="sync()"
      />
    </b-form-group>
  </b-form>
</template>

<script>
export default {
  model: {
    prop: 'catalog',
    event: 'sync'
  },
  props: {
    catalog: {
      type: Object,
      required: true
    },
    catalogs: {
      type: Array,
      required: true
    }
  },
  name: 'CatalogForm',
  data: () => ({}),
  computed: {
    parents () {
      let items = [
        {
          id: null,
          title: 'Нет'
        },
        ...Object.values(this.catalogs)
      ]

      return items
    }
  },
  beforeMount () {
    this.init()
  },
  methods: {
    init () {
      this.model = this.catalog
    },
    sync () {
      this.$emit('sync', this.model)
    }
  }
}
</script>

<style scoped>

</style>
